<template>
    <div class="timer_container">
        <div v-if="display_days" class="time_wrap">
            <p class="time">{{twoDigits(days)}}</p>
            <p class="text">{{$tc("strings.LBL_DAYS",days)}}</p>
        </div>
        <div v-if="display_hours" class="time_wrap">
            <p class="time">{{twoDigits(hours)}}</p>
            <p class="text">{{$tc("strings.LBL_HOURS",hours)}}</p>
        </div>
        <div class="time_wrap">
            <p class="time">{{twoDigits(minutes)}}</p>
            <p class="text">{{$tc("strings.LBL_MINS",minutes)}}</p>
        </div>
        <div class="time_wrap">
            <p class="time">{{twoDigits(seconds)}}</p>
            <p class="text">{{$tc("strings.LBL_SECONDS",seconds)}}</p>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Countdown",
        mounted() {
            this.timerId = setInterval(() => {
                this.now = Math.trunc((new Date()).getTime() / 1000);
                if ((this.dateNum - this.now) < 0) {
                this.$emit('onTick', 0);
                } else {
                this.$emit('onTick', this.dateNum - this.now);
                }
            }, 1000);
        },
        beforeDestroy() {
            clearInterval(this.timerId);
        },
        props: {
            date: {
                type: Date,
                required: true
            },
            display_days:{
                type:Boolean,
                required:false,
                default:true,
            },
            display_hours:{
                type:Boolean,
                required:false,
                default:true,
            },
        },
        data() {
            return {
                now: Math.trunc((new Date()).getTime() / 1000)
            }
        },
        methods: {
            twoDigits(value) {
                if (value < 10) {
                return "0" + value.toString();
                }
                return value.toString();
            }
        },
        computed: {
            dateNum() {
                return Math.trunc(this.date.getTime() / 1000);
            },
            seconds() {
                if ((this.dateNum - this.now) < 0) {
                return 0
                }
                return (this.dateNum - this.now) % 60;
            },
            minutes() {
                if ((this.dateNum - this.now) < 0) {
                return 0
                }
                return Math.trunc((this.dateNum - this.now) / 60) % 60;
            },
            hours() {
                if ((this.dateNum - this.now) < 0) {
                return 0
                }
                return Math.trunc((this.dateNum - this.now) / 60 / 60) % 24;
            },
            days() {
                if ((this.dateNum - this.now) < 0) {
                return 0
                }
                return Math.trunc((this.dateNum - this.now) / 60 / 60 / 24);
            }
        }
    }
</script>
<style scoped lang="scss">
    .timer_container{
        display: flex;
        justify-content: center;
        .time_wrap{
            width: 19.5rem;
            .time{
                font-family: FuturaPT;
                font-size: 9.6rem;
                line-height: 11.2rem;
                letter-spacing: 0.3rem;
                font-weight: bold;
                color: #0B1022;
            }
            .text{
                font-family: FuturaPT;
                font-size: 3.2rem;
                line-height: 1.2;
                letter-spacing: 0.1rem;
                font-weight: bold;
                color: rgba(11, 16, 34, 0.3);
            }
        }
        &.small{
            .time_wrap{
                width: 10rem;
                .time{
                    font-size: 5rem;
                    line-height: normal;
                }
                .text{
                    font-size: 2rem;
                }
            }
        }
    }
</style>
